import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox } from '@fortawesome/pro-solid-svg-icons';

import { Input } from '@buildoutinc/blueprint-react/ui/Input';
import { Label } from '@buildoutinc/blueprint-react/ui/Label';

import { Button } from 'components/ui/button';
import { showSnackbar } from 'components/ui/snackbar/helper';

import { post } from 'helpers/api';

interface Props {
  submitPartnerRequest: string;
}

export default function RequestForm({ submitPartnerRequest }: Props) {
  const [value, setValue] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!value.trim()) return;

    setSubmitting(true);

    try {
      await post(submitPartnerRequest, { syndicationInput: value });
      setSubmitted(true);
    } catch {
      showSnackbar({ text: 'Something went wrong submitting your request.', variant: 'danger' });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="mb-4">
      <div className="my-2 fs-large">
        <FontAwesomeIcon className="me-1" icon={faInbox} />
        Syndication Network Request Form
      </div>

      <form onSubmit={handleSubmit}>
        <Label className="mb-3" htmlFor="syndicationInput">
          <i>
            Please enter the name of any listing site that you would like to request consideration for Buildout&apos;s
            Syndication Network.
          </i>
        </Label>

        <div className="row">
          <div className="col-12 col-md-6 col-lg-5 col-xl-4">
            <div className="d-flex gap-2">
              <Input
                id="syndicationInput"
                required
                value={value}
                onChange={e => setValue(e.target.value)}
              />
              <Button disabled={submitting || submitted} render={<button type="submit" />} variant="primary">
                {submitted ? 'Submitted!' : 'Submit'}
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
